<p-messages></p-messages>
<div class="my-2" style="max-width: 50rem">
    @if (!_severity) {
        <p>
            <span>
                @for (_message of _messages; track $index) {
                    <p>{{ _message }}</p>
                }
            </span>
        </p>
    } @else if (_severity == 'warn') {
        <p-message icon="pi pi-exclamation-triangle" [severity]="_severity" [closable]="false">
            <span class="m-2">
                @for (_message of _messages; track $index) {
                    <p>{{ _message }}</p>
                }
            </span>
        </p-message>
    } @else {
        <p-message [severity]="_severity" [closable]="false">
            <span class="m-2">
                @for (_message of _messages; track $index) {
                    <p>{{ _message }}</p>
                }
            </span>
        </p-message>
    }
</div>

<div class="p-dialog-footer">
    <p-button
        [severity]="config.data?.cancelConfig?.severity"
        [label]="config.data?.cancelConfig?.label"
        [icon]="config.data?.cancelConfig?.icon"
        (click)="onCancel()"
    />

    <p-button
        [severity]="config.data?.confirmationConfig?.severity"
        [label]="config.data?.confirmationConfig?.label"
        [icon]="config.data?.confirmationConfig?.icon"
        (click)="onConfirm()"
    />
</div>
